import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlusCircle = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "plus",
	"data-name": "plus",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-6 -6 36 36",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 1.8851035,
			y1: 12,
			x2: 22.114897,
			y2: 12,
			id: "line1"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 12,
			y1: 1.8851035,
			x2: 12,
			y2: 22.114897,
			id: "line2"
		})
	]
});
const ForwardRef = forwardRef(SvgPlusCircle);
export default ForwardRef;
